export default __webpack_public_path__ + "static/media/Letter of Authority for BiofuelCircle.cb4dbc69.docx";